import { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import toast from "react-hot-toast";
import { getAmortizacionesDetalladas } from "../../utils/compromisos/amortizacionCompromiso";
import { Loader } from "../Loader";

// Modal COMPARTIDO (10.1) — "Ver amortizaciones" de un compromiso de pago (P1.10 redefinido).
// Lista las amortizaciones VIGENTES (reversado_at IS NULL) con fecha, movimiento y monto. Usado
// desde EstadoCuenta y, si hiciera falta, desde Futuros — toma solo `compromisoId` + datos de
// cabecera, no un shape de proyección.

const fmtMonto = (n, moneda) => {
  const pref = moneda === "USD" ? "US$ " : moneda === "PEN" ? "S/ " : "$";
  return pref + Number(n || 0).toLocaleString("es-CL", { maximumFractionDigits: moneda === "USD" ? 2 : 0 });
};

const fmtFecha = (f) => (f ? String(f).slice(0, 10).split("-").reverse().join("/") : "—");

const DetalleAmortizacionesCompromisoModal = ({ show, onHide, compromisoId, concepto }) => {
  const [cargando, setCargando] = useState(true);
  const [filas, setFilas] = useState([]);

  useEffect(() => {
    if (!show || !compromisoId) return;
    let vivo = true;
    (async () => {
      setCargando(true);
      try {
        const data = await getAmortizacionesDetalladas(compromisoId);
        if (vivo) setFilas(data);
      } catch (e) {
        toast.error(`Error al cargar amortizaciones: ${e.message || e}`);
      } finally {
        if (vivo) setCargando(false);
      }
    })();
    return () => {
      vivo = false;
    };
  }, [show, compromisoId]);

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1.1rem" }}>Amortizaciones{concepto ? ` — ${concepto}` : ""}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {cargando ? (
          <div style={{ maxHeight: 160, overflow: "hidden" }}>
            <Loader />
          </div>
        ) : filas.length === 0 ? (
          <div style={{ color: "#999", fontSize: "0.85rem" }}>Sin amortizaciones vigentes.</div>
        ) : (
          <table className="table table-sm" style={{ fontSize: "0.85rem" }}>
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Movimiento</th>
                <th style={{ textAlign: "right" }}>Monto</th>
              </tr>
            </thead>
            <tbody>
              {filas.map((a) => (
                <tr key={a.id}>
                  <td>{fmtFecha(a.fecha)}</td>
                  <td>{a.movimiento?.descripcion_raw || `Movimiento #${a.movimiento?.id ?? "—"}`}</td>
                  <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
                    {fmtMonto(a.monto_target, a.moneda_target)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={onHide}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DetalleAmortizacionesCompromisoModal;
